module.exports = {"back-to-media-list":"Back to media list","related":"Recent media articles","see-all":"See all articles"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/media-post.json
// module id = mWDo
// module chunks = 0